<script>
import RoundedBox from '@/components/RoundedBox.vue';

export default {
  name: 'Card',

  components: {
    RoundedBox,
  },

  props: {
    cardId: {
      type: String,
      default: '',
    },
    cardDraft: {
      type: Object,
      default: null,
    },
    currentId: {
      type: String,
      default: '',
    },
    setHeight: {
      type: Function,
      default: () => {},
    },
  },

  computed: {
    savedCard() {
      return this.$store.state.cards.allCards[this.cardId];
    },

    card() {
      const { cardId, cardDraft, $store } = this;
      if (cardDraft) {
        return cardDraft;
      }

      let card = this.savedCard;
      if (!card) {
        card = {
          id: '',
          title: '',
          subtitle: '',
          text: '',
          category: 'journey',
          type: 'free',
        };
      }
      return card;
    },
  },

  watch: {
    savedCard: {
      handler(card) {
        const { currentId, cardId, setHeight } = this;
        if (card && currentId === cardId) {
          this.$nextTick(() => {
            setHeight(cardId);
          });
        }
      },
      immediate: true,
    },
  },
};
</script>

<template>
  <RoundedBox :fullsize="true" :center="false" class="card">
    <div class="card-container">
      <div class="card-header">
        <v-skeleton-loader
          v-if="!card.title"
          type="heading"
          width="100%"
          class="card-title d-flex justify-center"
        >
        </v-skeleton-loader>
        <h3 class="card-title">
          {{ card.title }}
        </h3>
        <hr class="header-underline center" :class="card.category" />

        <h6 class="subtitle-heading subtitle mb-6 mt-1">
          {{ card.subtitle }}
        </h6>
      </div>

      <v-skeleton-loader v-if="!card.text" type="text@10, sentences"> </v-skeleton-loader>
      <div class="text">
        <p v-for="(p, index) in card.text.split('\n')" :key="index">
          {{ p }}
        </p>
      </div>
    </div>
  </RoundedBox>
</template>

<style lang="scss" scoped>
.card {
  .landing & {
    width: 320px;
    min-height: 580px;
    height: fit-content;
  }

  // .sm & {
  //   width: calc(100vw - 4rem);
  //   min-width: calc(100vw - 4rem);
  //   max-width: calc(100vw - 4rem);
  // }
}

.card-container {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

.card-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.card-title {
  margin-top: 0.5rem;
  margin-bottom: 0;
  text-align: center;
  line-height: 1em;
  min-width: fit-content;
  padding: 0 1rem;
}

.subtitle-heading {
  margin-top: 0;
  text-align: center;
  font-size: 1rem !important;
}

.text {
  flex: 1;
  text-indent: 1.5em;
  text-align: justify;
}
</style>
